export interface IOrganizationUserTableData {
    id: string;
    name: string;
    email: string;
    phoneNumber?: string;
    photoURL?: string;
    organizationRole: string;
    createdAt?: Date;
    isInvitee: boolean;
    isMe: boolean;
}
